import { Box, Container, Stack, Text } from '@mantine/core';

import { MarketingEyebrow } from '@/components/atoms';
import { useInView } from '@/hooks/useInView';
import { T } from '@/theme/assay';

/**
 * The founder's problem statement, straight after the hero - the "oh, that's me"
 * beat that the marketing site was missing. Sets up why grading exists at all.
 */
export function ProblemSection() {
  const { ref, inView } = useInView(0.2);

  return (
    <Box ref={ref} component="section" aria-labelledby="problem-heading" style={{ paddingTop: 24 }}>
      <Container size="lg">
        <Stack gap={24} maw={760}>
          <MarketingEyebrow label="The problem" inView={inView} />

          <Box
            component="h2"
            id="problem-heading"
            style={{
              fontFamily: '"Cormorant Garamond", serif',
              fontWeight: 300,
              fontSize: 'clamp(1.9rem, 3.6vw, 3rem)',
              lineHeight: 1.12,
              letterSpacing: '-0.02em',
              color: T.textPrimary,
              margin: 0,
              opacity: 0,
              animation: inView ? 'assay-word-rise 0.6s ease 0.5s both' : undefined,
            }}
          >
            Nobody loses touch{' '}
            <Box component="em" style={{ color: T.oreLight, fontStyle: 'italic' }}>
              on purpose
            </Box>
            .
          </Box>

          <Text
            style={{
              fontFamily: '"DM Mono", monospace',
              fontSize: '0.9rem',
              lineHeight: 1.75,
              color: T.textSecondary,
              maxWidth: 620,
              opacity: 0,
              animation: inView ? 'assay-word-rise 0.6s ease 0.65s both' : undefined,
            }}
          >
            The way most of us keep in touch is: remember someone at 11pm, feel guilty, do nothing.
            Hundreds of relationships you genuinely value, going quiet in the background, because
            there was never a system for it.
          </Text>

          <Text
            style={{
              fontFamily: '"DM Mono", monospace',
              fontSize: '0.9rem',
              lineHeight: 1.75,
              color: T.textSecondary,
              maxWidth: 620,
              opacity: 0,
              animation: inView ? 'assay-word-rise 0.6s ease 0.78s both' : undefined,
            }}
          >
            Every CRM is built for closing deals, not for keeping people. Assay answers one question
            instead: who am I losing touch with, and what should I say to them?
          </Text>
        </Stack>
      </Container>
    </Box>
  );
}
